<!-- Below md the breadcrumb asks for its full width and the actions wrap to a row of their own when they do not fit
     beside it, so a long name is not squeezed to nothing; from md the two sides share the width evenly around the
     centre slot. -->
<header class="flex min-h-16 shrink-0 flex-wrap items-center gap-2 md:flex-nowrap">
  <div class="flex h-16 min-w-0 grow items-center gap-2 overflow-hidden px-4 md:basis-0">
    <button hlmSidebarTrigger></button>
    <hlm-separator orientation="vertical" class="mr-2 data-vertical:h-4 data-vertical:self-center" />
    <nav hlmBreadcrumb class="min-w-0">
      <ol hlmBreadcrumbList class="flex-nowrap">
        <li hlmBreadcrumbItem>
          <a hlmBreadcrumbLink [link]="breadcrumbService.home">
            <ng-icon name="lucideHouse" />
            <span class="sr-only">Home</span>
          </a>
        </li>
        @for (item of breadcrumbService.items(); track $index; let last = $last) {
          <li hlmBreadcrumbSeparator></li>
          <li hlmBreadcrumbItem [class.min-w-0]="last">
            @if (item.link) {
              <a hlmBreadcrumbLink [link]="item.link" class="whitespace-nowrap">{{ item.label }}</a>
            } @else if (last) {
              <span hlmBreadcrumbPage class="truncate font-semibold">{{ item.label }}</span>
            } @else {
              <span class="whitespace-nowrap">{{ item.label }}</span>
            }
          </li>
        }
      </ol>
    </nav>
    @if (titleService.loading) {
      <hlm-spinner />
    }
  </div>
  @if (pageBar.centre(); as centre) {
    <div class="order-last flex w-full justify-center px-4 pb-3 md:order-none md:w-auto md:p-0">
      <ng-template [cdkPortalOutlet]="centre" />
    </div>
  }
  @if (pageBar.right() || pageBar.centre()) {
    <div class="ml-auto flex h-12 min-w-fit items-center justify-end gap-2 px-4 md:h-16 md:flex-1">
      @if (pageBar.right(); as right) {
        <ng-template [cdkPortalOutlet]="right" />
      }
    </div>
  }
</header>
